import ThemeConfig from '@/theme/theme.json';

import ThemeConfigSF from '@/theme/themeSF';
// import { Toast } from '@/utils/bridge';
import { createTheme, Theme, ThemeProvider } from '@mui/material';
import { ThemeOptions } from '@mui/material/styles';
import { enqueueSnackbar, SnackbarProvider } from 'notistack';
import React, { ReactNode, useEffect, useMemo, useState } from 'react';

/**
 * 封装一个方便调用的顶部消息显示条
 * @param msg 消息
 * @param type 类型
 */
const showMessage = (msg: string, type: 'error' | 'info' | 'success' | 'warning' | 'default') => {
  // 这里可以全局统一切换提示方案
  // Toast({
  //   type: type,
  //   content: msg,
  //   position: 'top',
  // });
  enqueueSnackbar(msg, {
    variant: type,
  });
};

/**
 * 一个Hook，返回皮肤能力
 * @returns
 */
const useThemeProvider = (): {
  /**
   * 主题组件，可以在jsx中用于最外层来使主题样式生效
   */
  ThemeProviderPro: React.FC<{ children: ReactNode }>;
  /**
   * 当前使用的皮肤配置
   */
  theme: Theme | null;
  /**
   * 顶部消息展示
   * @param msg 消息内容
   * @param type 消息类型
   * @returns
   */
  showMessage: (msg: string, type: 'error' | 'info' | 'success' | 'warning' | 'default') => void;
} => {
  const [theme, setTheme] = useState<Theme | null>(null);

  useEffect(() => {
    (async () => {
      let theme = null;
      if (BRAND === 'sensforge') {
        theme = ThemeConfigSF;
        await import('@/theme/themeSF.less');
      } else {
        theme = ThemeConfig as ThemeOptions;
      }
      const createdTheme = createTheme(theme);
      setTheme(createdTheme);
    })();
  }, []);

  const ThemeProviderPro: React.FC<{ children: ReactNode }> = useMemo(() => {
    return ({ children }) => {
      if (!theme) {
        return <></>;
      } else {
        return (
          <ThemeProvider theme={theme}>
            <SnackbarProvider
              maxSnack={1}
              autoHideDuration={2000}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              {children}
            </SnackbarProvider>
          </ThemeProvider>
        );
      }
    };
  }, [theme]);

  return {
    ThemeProviderPro,
    theme,
    showMessage,
  };
};

export default useThemeProvider;
